module.exports = __webpack_public_path__ + "static/media/UploadImageSvg.4b320931.svg";